import {formatMonetaryToBr} from '../../utils/formatMonetaryToBr'
import {TDistract} from '../../coreGlobal/models/sale'
import {CreditCardRefundStatus} from '../../pages/sales/components/CreditCardRefundStatus'
import {formatDateTime} from '../../utils/dayJs/format'

interface IDistract {
  data: TDistract[]
}

const CustomTd = ({children}) => {
  return <td style={{paddingTop: 3, paddingBottom: 3}}>{children}</td>
}

export const DistractList = ({data}: IDistract) => {
  return (
    <>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações do Distrato</h3>
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='row mb-6 mt-4'>
          <div className='col-12 table-responsive'>
            {data?.map((distract, index) => {
              let totalSessionsValue = 0
              let totalContractValue = 0
              let totalRemainingSessionsValue = 0
              let totalDeductedValue = 0
              let totalTableAdjustedValue = 0
              return (
                <div
                  key={`distractContainer${distract.id}`}
                  style={{
                    paddingBottom: '20px',
                    marginBottom: '20px',
                    borderBottom: index < data.length - 1 ? '2px solid #000' : 'none',
                  }}
                >
                  <table
                    className='table table-bordered table-row-gray-300 gy-7'
                    key={`distractList${distract.id}`}
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan={10}
                          className={`${
                            distract.status === 2
                              ? 'bg-success text-white p-4 text-center'
                              : distract.status === 1
                              ? 'bg-warning text-white p-4 text-center'
                              : 'bg-danger text-white p-4 text-center'
                          }`}
                        >
                          {distract.statusName}
                        </th>
                      </tr>
                      <tr
                        className='fw-bold fs-6 text-gray-800'
                        style={{backgroundColor: 'rgb(220 219 219)'}}
                      >
                        <th className='fw-bold col-4'>Nome</th>
                        <th className='fw-bold col-1'>Sessão</th>
                        <th className='fw-bold col-1'>Realizadas</th>
                        <th className='fw-bold col-1'>Canceladas</th>
                        <th className='fw-bold col-2'>Valor Utilizado</th>
                        <th className='fw-bold col-2'>Total</th>
                        <th className='fw-bold col-2'>Valor pendente</th>
                        <th className='fw-bold col-2'>Taxa ADM</th>
                        <th className='fw-bold col-2'>Restituição</th>
                      </tr>
                    </thead>
                    <tbody>
                      {distract.items.map((item, index) => {
                        totalSessionsValue += Number(item.realized_amount)
                        totalContractValue += Number(item.saleItem.totalPrice)
                        totalRemainingSessionsValue += Number(item.remaining_amount)
                        totalDeductedValue += Number(item.fee_amount)
                        totalTableAdjustedValue += Number(item.restitution_amount)
                        return (
                          <tr key={`distractListInternal${index}`}>
                            <CustomTd>{item.saleItem.product.name}</CustomTd>
                            <CustomTd>{item.saleItem.sessions}</CustomTd>
                            <CustomTd>{item.saleItem.sessionsRealized}</CustomTd>
                            <CustomTd>{item.saleItem.canceledSessions}</CustomTd>
                            <CustomTd>{formatMonetaryToBr(item.realized_amount)}</CustomTd>
                            <CustomTd>{formatMonetaryToBr(item.saleItem.totalPrice)}</CustomTd>
                            <CustomTd>{formatMonetaryToBr(item.remaining_amount)}</CustomTd>
                            <CustomTd>{formatMonetaryToBr(item.fee_amount)}</CustomTd>
                            <CustomTd>{formatMonetaryToBr(item.restitution_amount)}</CustomTd>
                          </tr>
                        )
                      })}
                      <tr style={{backgroundColor: 'rgb(220 219 219)'}}>
                        <td colSpan={4}>
                          <b>Totais</b>
                        </td>
                        <td>
                          <b>{formatMonetaryToBr(totalSessionsValue)}</b>
                        </td>
                        <td>
                          <b>{formatMonetaryToBr(totalContractValue)}</b>
                        </td>
                        <td>
                          <b>{formatMonetaryToBr(totalRemainingSessionsValue)}</b>
                        </td>
                        <td>
                          <b>{formatMonetaryToBr(totalDeductedValue)}</b>
                        </td>
                        <td>
                          <b>{formatMonetaryToBr(totalTableAdjustedValue)}</b>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={9}>
                          <b>Valor Total da Venda: </b> {formatMonetaryToBr(distract.saleAmount)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={9}>
                          <b>Valor Total Pago: </b>
                          {formatMonetaryToBr(distract.paidAmount)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={9}>
                          <b>Valor Multa: </b>
                          {formatMonetaryToBr(distract.fineAmount)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={9}>
                          <b>Valor {distract.refundedAmount > 0 ? 'Restituído' : 'Cobrado'}: </b>((
                          {formatMonetaryToBr(distract.saleAmount)} -{' '}
                          {formatMonetaryToBr(distract.calculatedAmount)}) -{' '}
                          {formatMonetaryToBr(distract.paidAmount)}) +{' '}
                          {formatMonetaryToBr(distract.fineAmount)} ={' '}
                          {formatMonetaryToBr(
                            distract.refundedAmount > 0
                              ? distract.refundedAmount * -1
                              : distract.chargedAmount
                          )}
                        </td>
                      </tr>
                      {distract.cancellationTypeName && (
                        <tr>
                          <td colSpan={9}>
                            <b>Tipo: </b>
                            {distract.cancellationTypeName}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={9}>
                          <b>Motivo do Cancelamento: </b>
                          {distract.reason}{' '}
                          {distract.reasonObservation?.trim() && (
                            <>
                              - <b>Observação:</b> {distract.reasonObservation}
                            </>
                          )}
                        </td>
                      </tr>
                      {distract?.voucher && (
                        <tr>
                          <td colSpan={9}>
                            <b className='mb-2'>Forma de estorno Voucher </b>
                            <table
                              className='table table-bordered table-row-gray-300 gy-7'
                              key={`distractListVoucher${distract.id}`}
                            >
                              <thead>
                                <tr>
                                  <th>Valor</th>
                                  <th>Expira EM</th>
                                  <th>E-mail Enviado</th>
                                  <th>Venda Utilizada</th>
                                  <th>Data Utilização</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{formatMonetaryToBr(distract.voucher?.amount)}</td>
                                  <td>
                                    {distract.voucher?.expiresAt
                                      ? formatDateTime(distract.voucher.expiresAt)
                                      : ''}
                                  </td>
                                  <td>{distract.voucher?.clientEmail}</td>
                                  <td>{distract.voucher?.billingID}</td>
                                  <td>
                                    {distract.voucher?.useAt
                                      ? formatDateTime(distract.voucher.useAt)
                                      : ''}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                      <tr
                        className='text-center min-w-100px'
                        style={{verticalAlign: 'middle', backgroundColor: 'rgb(220 219 219)'}}
                      >
                        <td colSpan={9}>
                          <b>Taxa ADM: </b>
                          {distract.percentage}%
                        </td>
                      </tr>
                      {distract.creditCardRefunds?.map((refund) => (
                        <tr key={`creditCardRefund${refund.id}`}>
                          <td colSpan={9}>
                            <b>Estorno Cielo: Valor de {formatMonetaryToBr(refund.amount)}</b>
                            <CreditCardRefundStatus
                              refund={refund}
                              onUpdated={() => window.location.reload()}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
